export default {
  SET_ZOOM: 'SET_ZOOM',
  SET_BACKGROUND_COLOR: 'SET_BACKGROUND_COLOR',
  SELECT_OBJECT: 'SELECT_OBJECT',
  SELECT_OBJECT_MULTIPLE: 'SELECT_OBJECT_MULTIPLE',
  DESELECT_OBJECTS: 'DESELECT_OBJECTS',
  FLIP_OBJECT_VERTICAL: 'FLIP_OBJECT_VERTICAL',
  FLIP_OBJECT_HORIZONTAL: 'FLIP_OBJECT_HORIZONTAL',
  ADD_NEW_TEXT_OBJECT: 'ADD_NEW_TEXT_OBJECT',
  ADD_NEW_IMAGE_OBJECT: 'ADD_NEW_IMAGE_OBJECT',
  ADD_NEW_STICKER_OBJECT: 'ADD_NEW_STICKER_OBJECT',
  EDIT_OBJECT: 'EDIT_OBJECT',
  EDIT_FONT: 'EDIT_FONT',
  TRANSFORM_OBJECT: 'TRANSFORM_OBJECT',
  MOVE_OBJECT: 'MOVE_OBJECT',
  DELETE_OBJECT: 'DELETE_OBJECT',
  COPY_OBJECT: 'COPY_OBJECT',
  SHOW_LAYERS: 'SHOW_LAYERS',
  HIDE_LAYERS: 'HIDE_LAYERS',
  TOGGLE_LAYERS: 'TOGGLE_LAYERS',
  TOGGLE_GUIDE: 'TOGGLE_GUIDE',
  SORT_LAYER: 'SORT_LAYER',
  UPDATE_OBJECT_SIZES: 'UPDATE_OBJECT_SIZES',
  ALIGN_HORIZONTAL_LEFT: 'ALIGN_HORIZONTAL_LEFT',
  ALIGN_HORIZONTAL_CENTER: 'ALIGN_HORIZONTAL_CENTER',
  ALIGN_HORIZONTAL_RIGHT: 'ALIGN_HORIZONTAL_RIGHT',
  ALIGN_VERTICAL_TOP: 'ALIGN_VERTICAL_TOP',
  ALIGN_VERTICAL_CENTER: 'ALIGN_VERTICAL_CENTER',
  ALIGN_VERTICAL_BOTTOM: 'ALIGN_VERTICAL_BOTTOM',
  SHOW_GRID: 'SHOW_GRID',
  HIDE_GRID: 'HIDE_GRID',
  TOGGLE_GRID: 'TOGGLE_GRID',
  SELECT_PANE: 'SELECT_PANE',

  SELECT_SURFACE: 'SELECT_SURFACE',
  SELECT_COLOR: 'SELECT_COLOR',

  CHECKOUT: 'CHECKOUT',

  CHANGE_AMOUNT: 'CHANGE_AMOUNT',

  SET_STICKER_CATEGORY: 'SET_STICKER_CATEGORY',

  SET_TEAM_MODE: 'SET_TEAM_MODE',
  SET_SINGLE_MODE: 'SET_SINGLE_MODE',
  SHOW_TEAM_MODAL: 'SHOW_TEAM_MODAL',
  HIDE_TEAM_MODAL: 'HIDE_TEAM_MODAL',

  SEARCH_STICKER: 'SEARCH_STICKER',
  FETCH_STICKER_SUCCESS: 'FETCH_STICKER_SUCCESS',
  FETCH_STICKER_FAILURE: 'FETCH_STICKER_FAILURE',
  RESET_STICKER_KEYWORD: 'RESET_STICKER_KEYWORD',

  SHOW_COPYRIGHT_MODAL: 'SHOW_COPYRIGHT_MODAL',
  HIDE_COPYRIGHT_MODAL: 'HIDE_COPYRIGHT_MODAL',
  TOGGLE_LOADING: 'SHOW_LOADING',

  ADD_NEW_TEMPLATE_TEXT: 'ADD_NEW_TEMPLATE_TEXT',
  UPDATE_TEMPLATE_TEXT: 'UPDATE_TEMPLATE_TEXT',
  ADD_NEW_TEMPLATE_IMAGE: 'ADD_NEW_TEMPLATE_IMAGE',
  UPDATE_TEMPLATE_IMAGE: 'UPDATE_TEMPLATE_IMAGE',
  DELETE_TEMPLATE_OBJECT: 'DELETE_TEMPLATE_OBJECT',

  ADD_NEW_TEMPLATE: 'ADD_NEW_TEMPLATE',

  /* For backward compatibility */
  ADD_TEMPLATE_OBJECT: 'ADD_TEMPLATE_OBJECT',
  UPDATE_TEMPLATE_OBJECT: 'UPDATE_TEMPLATE_OBJECT',
  SELECT_TEMPLATE_OBJECT: 'SELECT_TEMPLATE_OBJECT',

  // Face
  FACE_SET_PHASE: 'FACE_SET_PHASE',
  FACE_SET_IMAGE: 'FACE_SET_IMAGE',
  FACE_SET_MASK_IMAGE: 'FACE_SET_MASK_IMAGE', // 白塗り部分の画像
  FACE_UPDATE_LINES: 'FACE_UPDATE_LINES',
  FACE_ADD_LINE: 'FACE_ADD_LINE',
  FACE_SET_STROKE_WIDTH: 'FACE_SET_STROKE_WIDTH',
  FACE_SET_PEN_MODE: 'FACE_SET_PEN_MODE',
  FACE_SET_CROP_DATA: 'FACE_SET_CROP_DATA',
  FACE_SET_CROPPED_IMAGE: 'FACE_SET_CROPPED_IMAGE',
  FACE_SET_FINAL_IMAGE: 'FACE_SET_FINAL_IMAGE',
  FACE_MOVE_FINAL_IMAGE: 'FACE_MOVE_FINAL_IMAGE',
  FACE_REMOVE_CROPPED_IMAGE: 'FACE_REMOVE_CROPPED_IMAGE',
  FACE_REMOVE_FINAL_IMAGE: 'FACE_REMOVE_FINAL_IMAGE',
  FACE_LOAD_OBJECTS: 'FACE_LOAD_OBJECTS',
  CLOSE_TOUR: 'CLOSE_TOUR',
  SET_TOUR_STEP: 'SET_TOUR_STEP',
  SET_TEXT_LAYOUT: 'SET_TEXT_LAYOUT',
  SET_TEXT_VALUE: 'SET_TEXT_VALUE',
  FACE_SET_TEXT_FONT: 'FACE_SET_TEXT_FONT',
  FACE_SET_TEXT_COLOR: 'FACE_SET_TEXT_COLOR',
  FACE_SET_TEXT_SIZE: 'FACE_SET_TEXT_SIZE',
  FACE_ADD_EXTRA_ITEM: 'FACE_ADD_EXTRA_ITEM',
  SET_EXTRA_TEXT_VALUE: 'SET_EXTRA_TEXT_VALUE',
  SET_EXTRA_TEXT_FONT: 'SET_EXTRA_TEXT_FONT',
  SET_EXTRA_TEXT_COLOR: 'SET_EXTRA_TEXT_COLOR',
  SET_EXTRA_TEXT_SIZE: 'SET_EXTRA_TEXT_SIZE',
  SET_MEISHI_AMOUNT: 'SET_MEISHI_AMOUNT'
};


// WEBPACK FOOTER //
// ./src/actions/types.js